// Mirror of the server's money rules (backend validators.js): integer cents everywhere, dollars only at the edges.
const MAX_CENTS = 99999999;
export function parseDollars(s) {
  if (s === null || s === undefined) return null;
  const t = String(s).replace(/[$\s]/g, '');
  const m = t.match(/^(\d{1,3}(?:,\d{3})+|\d*)(?:\.(\d{1,2}))?$/); if (!m || (m[1] === '' && !m[2])) return null;   // '.50' is fifty cents; '.' alone is nothing
  const cents = (m[1] ? parseInt(m[1].replace(/,/g, ''), 10) : 0) * 100 + (m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0);
  return cents > MAX_CENTS ? null : cents;
}
export function formatDollars(cents) { if (!Number.isInteger(cents)) return ''; const a = Math.abs(cents); return `${cents < 0 ? '-' : ''}$${Math.floor(a / 100).toLocaleString('en-US')}.${String(a % 100).padStart(2, '0')}`; }
export const centsToInput = cents => (Number.isInteger(cents) ? (cents / 100).toFixed(2) : '');
